/**
 * Trompos Space Rewards 1.0 (beta opt-in)
 * - Sin MutationObserver, sin polling periódico; una sola ejecución por cambio de carrito.
 * - No crea descuentos: el regalo solo se conserva si Shopify lo calcula a cero.
 * - No se ejecuta si no está incluido el snippet de configuración.
 * - SOLO compatible y activable para carrito EUR. No garantiza checkout acelerado.
 */
(() => {
  'use strict';
  const el = document.getElementById('ts-space-rewards-config');
  if (!el) return;
  let config;
  try { config = JSON.parse(el.textContent); } catch { return; }
  if (!config?.gifts?.length) return;
  const gifts = config.gifts.filter(g => Number.isSafeInteger(g.id) && g.id > 0 && Number.isSafeInteger(g.productId) && g.productId > 0);
  if (!gifts.length) { console.warn('[Space Rewards] Variantes no resueltas. Sin cambios.'); return; }
  const root = window.Shopify?.routes?.root || '/';
  const url = path => `${root.replace(/\/$/, '')}/${path}`;
  let timer = null;
  let running = false;
  let queued = false;
  const denied = new Set();

  async function request(path, options) {
    const res = await fetch(url(path), { credentials: 'same-origin', ...options });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || `HTTP ${res.status}`);
    return data;
  }
  const read = () => request('cart.js', { cache: 'no-store' });
  const managed = item => Boolean(item.properties && item.properties._ts_space_reward);
  const giftOf = item => gifts.find(g => Number(item.variant_id) === g.id);

  function eligibleTotal(cart) {
    // El importe se calcula con los productos comprados, nunca con los regalos.
    // Solo EUR, de momento, para que 20/35/50 no cambien por divisas.
    return cart.items.reduce((sum, item) => {
      if (managed(item) || giftOf(item)) return sum;
      return sum + Number(item.final_line_price || 0);
    }, 0);
  }
  async function change(item, quantity) {
    return request('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', Accept:'application/json' },
      body: JSON.stringify({ id:item.key, quantity })
    });
  }
  async function add(g) {
    return request('cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({ items:[{ id:g.id, quantity:1, properties:{ _ts_space_reward:g.key } }] })
    });
  }
  async function refreshDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) return;
    try {
      // Actualizar solo el dialogo, conservando el overlay y sus handlers nativos.
      const sectionResponse = await fetch(`${url('cart')}?section_id=cart-drawer`, {credentials:'same-origin'});
      if (sectionResponse.ok) {
        const html = new DOMParser().parseFromString(await sectionResponse.text(), 'text/html');
        const source = html.querySelector('cart-drawer .drawer__inner');
        const target = drawer.querySelector('.drawer__inner');
        if (source && target) {
          drawer.classList.toggle('is-empty', !!html.querySelector('cart-drawer.is-empty'));
          target.replaceWith(source);
        }
      }
      const iconResponse = await fetch(`${url('cart')}?section_id=cart-icon-bubble`, {credentials:'same-origin'});
      if (iconResponse.ok) {
        const html = new DOMParser().parseFromString(await iconResponse.text(), 'text/html');
        const src = html.querySelector('#cart-icon-bubble');
        const dst = document.querySelector('#cart-icon-bubble');
        if (src && dst) dst.innerHTML = src.innerHTML;
      }
    } catch (err) { console.warn('[Space Rewards] Fallo al refrescar vista', err); }
  }

  async function reconcile() {
    if (running) { queued = true; return; }
    running = true;
    try {
      const cart = await read();
      if (cart.currency !== config.currency) return;
      const total = eligibleTotal(cart);
      let modified = false;
      // Una mutación por iteración: evita conflictos de claves de línea y descuentos.
      for (let i=0; i<8; i++) {
        const latest = i === 0 ? cart : await read();
        let did = false;
        for (const g of gifts) {
          const own = latest.items.find(it => Number(it.variant_id) === g.id && it.properties?._ts_space_reward === g.key);
          const other = latest.items.some(it => Number(it.variant_id) === g.id && !managed(it));
          const eligible = total >= g.threshold && latest.items.some(it => !managed(it) && !giftOf(it) && it.quantity > 0);
          if (own && (!eligible || denied.has(g.key))) {
            await change(own, 0); modified = did = true; break;
          }
          if (own && own.quantity !== 1) {
            await change(own, 1); modified = did = true; break;
          }
          if (eligible && !own && !other && !denied.has(g.key)) {
            await add(g); modified = did = true; break;
          }
        }
        if (!did) break;
      }
      // Fail-safe: si no se aplica un descuento real del 100 %, eliminar regalo.
      let check = await read();
      for (const item of check.items) {
        if (!managed(item)) continue;
        if (Number(item.final_line_price) > 0) {
          const g = giftOf(item);
          if (g) denied.add(g.key);
          await change(item, 0);
          modified = true;
          console.warn('[Space Rewards] Regalo retirado: Shopify no lo ha descontado al 100 %. Revisar regla nativa.', g?.key);
        }
      }
      if (modified) await refreshDrawer();
    } catch (error) {
      console.warn('[Space Rewards] Error no bloqueante', error);
    } finally {
      running = false;
      if (queued) { queued=false; schedule(); }
    }
  }
  function schedule() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(() => { timer=null; reconcile(); }, 420);
  }
  function bind() {
    document.addEventListener('ts-space-cart-changed', schedule);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        if (event?.source === 'ts-space-rewards') return;
        schedule();
      });
    }
    if ('requestIdleCallback' in window) window.requestIdleCallback(schedule, {timeout:2000});
    else window.addEventListener('load', schedule, {once:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once:true});
  else bind();
})();
